document.addEventListener("DOMContentLoaded", function () {
    const sizeGuideTriggers = document.querySelectorAll('.c-size-guide-trigger');

    sizeGuideTriggers.forEach(trigger => {
        trigger.addEventListener('click', async function (event) {
            event.preventDefault();

            // Get the size guide URL from the data attribute
            const sizeGuideUrl = this.getAttribute('data-size-guide');
            if (sizeGuideUrl) {
                try {
                    // Fetch the content of the size guide
                    const response = await fetch(sizeGuideUrl);
                    if (!response.ok) throw new Error("Failed to fetch size guide content.");
                    
                    const html = await response.text();
                    
                    // Parse the HTML to extract the <main> element
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    const mainContent = doc.querySelector('main');

                    if (mainContent) {
                        // Create the modal container
                        const modal = document.createElement('div');
                        modal.classList.add('c-size-guide-modal');

                        // Add the <main> content to the modal
                        modal.innerHTML = `
                            <div class="c-size-modal-overlay"></div>
                            <div class="c-size-modal-content">
                                <button class="c-size-modal-close">&times;</button>
                                <div class="c-size-modal-body">${mainContent.innerHTML}</div>
                            </div>
                        `;

                        // Append modal to the body
                        document.body.appendChild(modal);

                        // Add event listener to close the modal
                        modal.querySelector('.c-size-modal-close').addEventListener('click', () => {
                            modal.remove();
                        });

                        // Close modal when clicking outside content
                        modal.querySelector('.c-size-modal-overlay').addEventListener('click', () => {
                            modal.remove();
                        });
                    } else {
                        console.error("No <main> element found in the response.");
                    }
                } catch (error) {
                    console.error("Error loading size guide:", error);
                }
            } else {
                console.error("Size guide URL is missing.");
            }
        });
    });
});
